export function normalizeVisibleName(value: string | null | undefined): string {
  return value?.replace(/^[\s\u200B-\u200D\uFEFF]+|[\s\u200B-\u200D\uFEFF]+$/gu, '') ?? '';
}

export function visibleNameIncludes(
  haystack: string | null | undefined,
  needle: string | null | undefined
): boolean {
  const normalizedNeedle = normalizeVisibleName(needle).toLowerCase();
  if (!normalizedNeedle) return true;
  return normalizeVisibleName(haystack).toLowerCase().includes(normalizedNeedle);
}

export function withNormalizedSearchFilter(filters: string[], search: string): string[] {
  const normalized = normalizeVisibleName(search);
  return filters.map((filter) => (filter === search ? normalized : filter)).filter(Boolean);
}
